<div class="accordion-block">
    <div class="accordion-header" [class.p-0]="!showExpand && !showTitle" [class.clickable]="showExpand" (click)="toggleExpanded()">
        <div class="accordion-title" *ngIf="showTitle">
            <img src="/images/{{stepImagePath}}/Pointer {{section}}.svg" alt="Pointer {{section}}.svg" />
            <span>{{title}}</span>
        </div>
        <div class="accordion-icon" *ngIf="showExpand" [class.expanded]="expanded">
            <img src="/images/icons/arrow/up-arrow.svg" alt="up-arrow.svg" />
            <img src="/images/icons/arrow/down-arrow.svg" alt="down-arrow.svg" />
        </div>
    </div>
    <div class="accordion-body" [class.expanded]="expanded">
        <ng-content></ng-content>
    </div>
</div>
